"use client";

import { useEffect, useState } from "react";

import { formatLocaleOf, uiLanguageOf, type UiLanguage } from "@/lib/site/site-routing";

const COPY: Record<UiLanguage, { title: string; description: string; retry: string }> = {
  zh: { title: "应用发生错误", description: "抱歉，页面无法正常显示，请刷新重试。", retry: "重试" },
  "zh-tw": { title: "應用程式發生錯誤", description: "抱歉，頁面無法正常顯示，請重新整理後重試。", retry: "重試" },
  en: { title: "Something went wrong", description: "Sorry, this page could not be displayed. Please refresh and try again.", retry: "Try again" },
  ja: { title: "エラーが発生しました", description: "ページを正しく表示できませんでした。再読み込みしてお試しください。", retry: "再試行" },
  ko: { title: "오류가 발생했습니다", description: "죄송합니다. 페이지를 표시할 수 없습니다. 새로고침한 후 다시 시도해 주세요.", retry: "다시 시도" },
  de: { title: "Es ist ein Fehler aufgetreten", description: "Die Seite konnte leider nicht angezeigt werden. Bitte laden Sie sie neu und versuchen Sie es erneut.", retry: "Erneut versuchen" },
  fr: { title: "Une erreur s'est produite", description: "Désolé, cette page n'a pas pu s'afficher. Veuillez actualiser et réessayer.", retry: "Réessayer" },
  es: { title: "Se ha producido un error", description: "Lo sentimos, no se pudo mostrar esta página. Actualice e inténtelo de nuevo.", retry: "Reintentar" },
  ru: { title: "Произошла ошибка", description: "К сожалению, страницу не удалось отобразить. Обновите её и попробуйте снова.", retry: "Повторить" },
  pt: { title: "Ocorreu um erro", description: "Desculpe, não foi possível exibir esta página. Atualize e tente novamente.", retry: "Tentar novamente" },
};

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const [copyKey, setCopyKey] = useState<UiLanguage>("zh");
  const copy = COPY[copyKey];

  useEffect(() => {
    console.error("[global] 应用发生严重错误:", error);
  }, [error]);

  useEffect(() => {

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setCopyKey(uiLanguageOf(navigator.language || ""));
  }, []);

  return (
    <html lang={formatLocaleOf(copyKey)}>
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "1rem",
          fontFamily: "system-ui, sans-serif",
          textAlign: "center",
          padding: "0 1.5rem",
          color: "#0f172a",
          background: "#fff",
        }}
      >
        <h1 style={{ fontSize: "1.25rem", fontWeight: 600, margin: 0 }}>
          {copy.title}
        </h1>
        <p style={{ fontSize: "0.875rem", color: "#64748b", margin: 0 }}>
          {copy.description}
        </p>
        <button
          type="button"
          onClick={reset}
          style={{
            cursor: "pointer",
            borderRadius: "0.5rem",
            border: "none",
            background: "#2563eb",
            color: "#fff",
            padding: "0.5rem 1rem",
            fontSize: "0.875rem",
            fontWeight: 500,
          }}
        >
          {copy.retry}
        </button>
      </body>
    </html>
  );
}
